/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Resource types exposed via the ImageBuilder API.
 */
export enum ResourceKind {
  IMAGE_BUILD = 'ImageBuild',
  IMAGE_EXPORT = 'ImageExport',
  IMAGE_PROMOTION = 'ImagePromotion',
}
